







































import Vue from 'vue'
import { mapGetters } from 'vuex'

/* eslint-disable */ 
import { Year } from '../models/Year'
import { Model } from '../models/Model'
/* eslint-enable */ 

import { bus } from '../main'

export default Vue.extend({
  data () {
    return {     
      modelId: null as string | null,
      yearId: null as number | null      
    }
  },
  props: ['column'],
  computed: {
    ...mapGetters({
      make: 'makes/currentMake',
      yearModels: 'models/yearModels',
      carouselModels: 'models/carouselModels',
      currentModel: 'models/currentModel',
      years: 'years/yearsForMake',
      selectedModelId: 'models/currentModelId'
    }),
    disabled() : boolean {
      return this.yearId === null ? true : false
    },
    cols() : number {
      if (this.column === true) {
        return 12
      } else {
        const { xs, sm } = this.$vuetify.breakpoint
        return xs || sm ? 12 : 3
      }
    }
  },
  watch: {
    make: {
      handler(val) {
        this.$store.dispatch('years/reloadYears', { makeId: val.id })
      }
    }
    
  },
  async mounted() {
    bus.$on('carouselItemClicked', this.setYearAndModel)
    // Autopopulate dropdowns if there is already a model selected
    if (this.currentModel !== null) {
      this.setYearAndModel(this.currentModel)
    }
  },
  methods: {
    onYearChanged(yearId : number) : void {
      this.getModelsForYear(yearId)
    },
    async onYearModelSelected(selectedModel: string) {
      const model = this.yearModels.find((model: Model) => model.id === selectedModel)
      this.$store.commit('models/setCurrentModel', model)
      await this.$store.dispatch('trims/reloadTrims', { modelId: this.selectedModelId })
    },
    async onCarouselModelSelected(selectedModel: Model) {
      this.$store.commit('models/setCurrentModel', selectedModel)
      await this.$store.dispatch('trims/reloadTrims', { modelId: this.selectedModelId })
    },
    async getModelsForYear(yearId: number) {
      this.$store.dispatch('models/reloadYearModels', { makeId: this.make.id, yearId: yearId })
    },
    setYearAndModel(model : Model) {
      this.years.forEach((year: Year) => {
        if (year.year == model.year) {
          this.yearId = year.id
          this.onYearChanged(this.yearId)
        }
      })
      this.modelId = model.id
      this.onCarouselModelSelected(model)
    }
  }
})
